<template>
  
    <div class="pt-6">
        <Calendar></Calendar>
    </div>

</template>

<script>
import Calendar from '@/components/Calendar.vue'

export default {
    components: {
		Calendar
	},

    created() {
		this.$store.commit('SET_TITLE', 'Vacations calendar')
	}
}
</script>